/**
 * CMSD Version 1
 *
 *
 * @beta
 */
export const CMSD_V1 = 1
